import { TrashIcon } from '@heroicons/react/20/solid';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const SKURow = ({ sku, hideLabels = true, onSKUChange, onDelete }) => {
	const [skuNumber, setSKUNumber] = useState(sku?.sku_number || '');
	const [label, setLabel] = useState(sku?.label || '');
	const [description, setDescription] = useState(sku?.description || '');
	const [interventionCode, setInterventionCode] = useState(
		sku?.intervention_code || '',
	);
	const [interventionDescription, setInterventionDescription] = useState(
		sku?.intervention_desc || '',
	);

	useEffect(() => {
		onSKUChange({
			...sku,
			sku_number: skuNumber,
			label,
			description,
			intervention_code: interventionCode,
			intervention_desc: interventionDescription,
		});
	}, [
		skuNumber,
		label,
		description,
		interventionCode,
		interventionDescription,
	]);

	return (
		<>
			<div className="form-control">
				<label
					htmlFor="sku-number"
					className={cn('label', 'label-text', { hidden: hideLabels })}
				>
					SKU Number
				</label>
				<input
					id="sku-number"
					className="input input-sm input-bordered"
					type="text"
					value={skuNumber}
					onChange={({ target }) => setSKUNumber(target.value)}
				/>
			</div>
			<div className="form-control">
				<label
					htmlFor="sku-label"
					className={cn('label', 'label-text', { hidden: hideLabels })}
				>
					Label
				</label>
				<input
					id="sku-label"
					className="input input-sm input-bordered"
					type="text"
					value={label}
					onChange={({ target }) => setLabel(target.value)}
				/>
			</div>
			<div className="col-span-2 form-control">
				<label
					htmlFor="sku-description"
					className={cn('label', 'label-text', { hidden: hideLabels })}
				>
					Description
				</label>
				<input
					id="sku-description"
					className="w-full input input-sm input-bordered"
					type="text"
					value={description}
					onChange={({ target }) => setDescription(target.value)}
				/>
			</div>
			<div className="form-control">
				<label
					htmlFor="intervention-code"
					className={cn('label', 'label-text', { hidden: hideLabels })}
				>
					Intervention Code
				</label>
				<input
					id="intervention-code"
					className="input input-sm input-bordered"
					type="text"
					value={interventionCode}
					onChange={({ target }) => setInterventionCode(target.value)}
				/>
			</div>
			<div className="col-span-2 form-control">
				<label
					htmlFor="intervention-description"
					className={cn('label', 'label-text', { hidden: hideLabels })}
				>
					Intervention Description
				</label>
				<div className="flex flex-row gap-2">
					<input
						id="intervention-description"
						className="w-full input input-sm input-bordered"
						type="text"
						value={interventionDescription}
						onChange={({ target }) => setInterventionDescription(target.value)}
					/>
					<button className="btn btn-square btn-sm" onClick={onDelete}>
						<TrashIcon className="w-4 h-4" />
					</button>
				</div>
			</div>
		</>
	);
};

SKURow.propTypes = {
	sku: PropTypes.object,
	hideLabels: PropTypes.bool,
	onSKUChange: PropTypes.func,
	onDelete: PropTypes.func,
};

export default SKURow;
